import { useState } from 'react';
import { MessageTemplateStatusClient, MessageTemplateStatusDTO } from '../services/apiClient';
import { API_BASE_URL } from '../config/config';
import axiosInstance from '../services/axiosInstance';

export const useMessageTemplateStatusApi = () => {
    const apiClient = new MessageTemplateStatusClient(API_BASE_URL, axiosInstance);

    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const create = async (data: MessageTemplateStatusDTO) => {
        setIsLoading(true);
        try {
            await apiClient.createMessageTemplateStatus(data);
        } catch (err: any) {
            setError(err.message || 'Error creating MessageTemplateStatus');
        } finally {
            setIsLoading(false);
        }
    };

    const edit = async (id: string, data: MessageTemplateStatusDTO) => {
        setIsLoading(true);
        try {
            await apiClient.updateMessageTemplateStatus(id, data);
        } catch (err: any) {
            setError(err.message || 'Error updating MessageTemplateStatus');
        } finally {
            setIsLoading(false);
        }
    };

    const getById = async (id: string) => {
        setIsLoading(true);
        try {
            return await apiClient.getMessageTemplateStatusById(id);
        } catch (err: any) {
            setError(err.message || 'Error fetching MessageTemplateStatus');
        } finally {
            setIsLoading(false);
        }
    };

    const search = async (filters: any) => {
        setIsLoading(true);
        try {
            return await apiClient.searchMessageTemplateStatuses(filters);
        } catch (err: any) {
            setError(err.message || 'Error searching MessageTemplateStatuses');
        } finally {
            setIsLoading(false);
        }
    };

    const remove = async (id: string) => {
        setIsLoading(true);
        try {
            await apiClient.deleteMessageTemplateStatus(id);
        } catch (err: any) {
            setError(err.message || 'Error deleting MessageTemplateStatus');
        } finally {
            setIsLoading(false);
        }
    };

    return { create, edit, getById, search, remove, isLoading, error };
};